import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { FormGroup, Input } from 'reactstrap'
import { saveToolbox } from 'store/AddWidget/actions'

function NewWidgetForm({ setMode }) {
  const dispatch = useDispatch()

  const [toolboxId, setToolboxId] = useState('')
  const [name, setName] = useState('')
  const [height, setHeight] = useState('')
  const [width, setWidth] = useState('')
  const [xPosition, setXPosition] = useState('')
  const [yPosition, setYPosition] = useState('')
  const [adminChecked, setAdminChecked] = useState(true)
  const [managerChecked, setManagerChecked] = useState(false)
  const [employeeChecked, setEmployeeChecked] = useState(false)

  const { adminToolbox, managerToolbox, employeeToolbox } = useSelector(
    (store) => store.addWidget
  )

  const adminToolboxIds =
    adminToolbox && adminToolbox.map((toolbox) => toolbox.id)

  const newToolbox = {
    id: toolboxId,
    name,
    active: 'false',
    layout: {
      h: height,
      w: width,
      x: xPosition,
      y: yPosition,
      i: toolboxId,
      moved: '0',
      static: '0',
    },
  }

  const returnToolBox = (id) => {
    switch (id) {
      case 1:
        return adminToolbox
      case 2:
        return managerToolbox
      case 3:
        return employeeToolbox
      default:
        return []
    }
  }

  const handleSubmit = () => {
    const dashboardIds = [
      { id: 1, checked: adminChecked },
      { id: 2, checked: managerChecked },
      { id: 3, checked: employeeChecked },
    ]

    const chosenAccesses = dashboardIds.filter(
      (dashboard) => dashboard.checked === true
    )

    if (!chosenAccesses.length) {
      alert('You must choose at least one access')
      return
    }

    for (const access of chosenAccesses) {
      const toolbox = returnToolBox(access.id)
      dispatch(saveToolbox(access.id, [...toolbox, newToolbox], newToolbox))
    }
    setMode('sync')
  }

  return (
    <div className='h-fit my-2 border shadow-lg rounded-lg p-3 w-50 mx-auto'>
      <h2>Add Widget</h2>
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='toolboxId'>
          Id
        </label>
        <Input
          id='toolboxId'
          name='id'
          type='text'
          style={{ height: '37px' }}
          value={toolboxId}
          onChange={(e) => setToolboxId(e.target.value)}
        />
      </FormGroup>
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='toolboxName'>
          Name
        </label>
        <Input
          id='toolboxName'
          name='last_name'
          type='text'
          style={{ height: '37px' }}
          onChange={(e) => setName(e.target.value)}
          defaultValue={name}
        />
      </FormGroup>
      <div className='d-flex items-center'>
        <div
          className='custom-control custom-checkbox mb-3'
          style={{ zIndex: '0' }}
        >
          <input
            className='custom-control-input'
            id='adminToolbox'
            defaultChecked={adminChecked}
            type='checkbox'
            onChange={() => setAdminChecked(!adminChecked)}
          />
          <label className='custom-control-label' htmlFor='adminToolbox'>
            Admin
          </label>
        </div>
        <div
          className='custom-control custom-checkbox mb-3 mx-5'
          style={{ zIndex: '0' }}
        >
          <input
            className='custom-control-input'
            id='managerToolbox'
            defaultChecked={managerChecked}
            onChange={() => setManagerChecked(!managerChecked)}
            type='checkbox'
          />
          <label className='custom-control-label' htmlFor='managerToolbox'>
            Manager
          </label>
        </div>
        <div
          className='custom-control custom-checkbox mb-3'
          style={{ zIndex: '0' }}
        >
          <input
            className='custom-control-input'
            id='employeeToolbox'
            defaultChecked={employeeChecked}
            onChange={() => setEmployeeChecked(!employeeChecked)}
            type='checkbox'
          />
          <label className='custom-control-label' htmlFor='employeeToolbox'>
            Employee
          </label>
        </div>
      </div>

      <h3 className='my-2'>Layout</h3>
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='widgetHeight'>
          Height
        </label>
        <Input
          id='widgetHeight'
          name='last_name'
          type='text'
          style={{ height: '37px' }}
          defaultValue={height}
          onChange={(e) => setHeight(e.target.value)}
        />
      </FormGroup>
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='widgetWidth'>
          Width
        </label>
        <Input
          id='widgetWidth'
          name='last_name'
          type='text'
          style={{ height: '37px' }}
          defaultValue={width}
          onChange={(e) => setWidth(e.target.value)}
        />
      </FormGroup>
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='xPosition'>
          xPosition
        </label>
        <Input
          id='xPosition'
          name='last_name'
          type='text'
          style={{ height: '37px' }}
          defaultValue={xPosition}
          onChange={(e) => setXPosition(e.target.value)}
        />
      </FormGroup>
      <FormGroup className='ml-0'>
        <label className='form-control-label' htmlFor='yPosition'>
          yPosition
        </label>
        <Input
          id='yPosition'
          name='last_name'
          type='text'
          style={{ height: '37px' }}
          defaultValue={yPosition}
          onChange={(e) => setYPosition(e.target.value)}
        />
      </FormGroup>
      <button onClick={handleSubmit} className='btn btn-info'>
        Add Widget
      </button>
    </div>
  )
}

export default NewWidgetForm
